export default function HeroSection() {
  return (
    <section className="relative w-full h-screen min-h-[600px] overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Abstract%20architectural%20interior%20with%20smooth%20concrete%20surfaces%20soft%20warm%20sand%20and%20cream%20light%20beams%20filtering%20through%20translucent%20glass%20partitions%20pronounced%20depth%20of%20field%20blur%20in%20background%20no%20human%20figures%20warm%20ambient%20tones%20minimalist%20modern%20space%20with%20geometric%20forms%20and%20gentle%20shadows&width=1800&height=1200&seq=analitikos-hero-01&orientation=landscape"
        alt="Abstract modern architectural interior with warm ambient lighting and geometric forms"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />

      <div className="absolute inset-0 bg-gradient-to-r from-black/40 via-black/20 to-transparent"></div>

      <div className="relative z-10 h-full flex items-center">
        <div className="w-full px-8 md:px-12 lg:pl-[8%]">
          <h1 className="text-white font-bold leading-[1.05] max-w-3xl">
            <span className="block text-[56px] md:text-[72px] lg:text-[80px]">ANALITIKOS</span>
            <span className="block text-[56px] md:text-[72px] lg:text-[80px]">SISTEMOS</span>
          </h1>

          <p className="mt-6 text-lg md:text-xl text-white/80 font-light max-w-xl leading-relaxed">
            Modern Digital Software Solutions for the iOS Platform
          </p>

          <div className="mt-12 h-px w-16 bg-white/30"></div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10">
        <div className="w-5 h-8 rounded-full border border-white/30 flex items-start justify-center p-1">
          <div className="w-1 h-2 rounded-full bg-white/60 animate-bounce"></div>
        </div>
      </div>
    </section>
  );
}